import React, {useEffect, useMemo} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Checkbox, Grid, Select} from 'semantic-ui-react';
import {Actions} from '../../../../common/actions';
import CommercialTable from '../../../../common/components/commercialTable/commercialTable';
import {DefaultColumnFilter} from '../../../../manageOrders/components/internalCommons/TableFilters';
import WtsSkillsModal from './skillsModal';
import WtsSkillsTechDetailsModal from './skillsTechDetailsModal';

const {
  getWtsSkills,
  getWtsCoursesAreas,
  updateWtsSkill,
} = Actions;

function WtsSkills({activeTab}) {
  const wtsCoursesAreas = useSelector((state) => state.wtsCoursesAreas.coursesAreas || []);
  const skillsData = useSelector((state) => state.wtsSkills.skills || state.wtsSkills.list || []);
  const areaSelected = useSelector((state) => state.wtsAreas.areaSelected);
  const dispatch = useDispatch();

  useEffect(() => {
    if (areaSelected && activeTab === 5) {
      dispatch(getWtsCoursesAreas(areaSelected.id));
      dispatch(getWtsSkills({'area': areaSelected.id}));
    }
  }, [areaSelected, activeTab]);

  const updateStatus = async(e, checkedValue, item) => {
    e.preventDefault();
    dispatch(updateWtsSkill(areaSelected.id, {
      'data': {
        ...item,
        'status': checkedValue ? 'A' : 'I',
      },
    }));
    dispatch(getWtsSkills({'area': areaSelected.id}));
  };

  const SelectColumnFilter = ({
    'column': {filterValue, setFilter},
  }) => {
    const options = [
      {'key': 'all', 'value': '', 'text': 'TODOS'},
      {'key': 'active', 'value': 'A', 'text': 'ACTIVO'},
      {'key': 'inactive', 'value': 'I', 'text': 'INACTIVO'},
    ];

    return (
      <Select
        compact
        placeholder="TODOS"
        value={filterValue || ''}
        options={options}
        style={{'minWidth': '120px', 'width': '100%'}}
        onChange={(e, {value}) => {
          setFilter(value || '');
          if (!value && areaSelected) {
            dispatch(getWtsSkills({'area': areaSelected.id}));
          }
        }}
      />
    );
  };

  const formattedData = useMemo(() => {
    const source = Array.isArray(skillsData) ? skillsData : [];
    return source.map((skill) => {
      const areaInfo = wtsCoursesAreas.find((a) =>
        String(a.id) === String(skill.course_area));
      return {
        ...skill,
        'area_name': areaInfo ? areaInfo.course_area : 'Sin asignar',
      };
    });
  }, [skillsData, wtsCoursesAreas]);

  const columns = useMemo(() => [
    {
      'Header': () => <span className="header-title">CÓDIGO AREA</span>,
      'accessor': 'course_area',
    },
    {
      'Header': () => <span className="header-title">ÁREA</span>,
      'accessor': 'area_name',
    },
    {
      'Header': () => <span className="header-title">CÓDIGO HABILIDAD</span>,
      'accessor': 'id',
    },
    {
      'Header': () => <span className="header-title">HABILIDAD</span>,
      'accessor': 'description',
    },
    {
      'Header': () => <span className="header-title">ESTADO</span>,
      'accessor': 'status',
      'Filter': SelectColumnFilter,
      'filter': (rows, id, filterValue) => {
        if (filterValue === '' || !filterValue) {
          return rows;
        }
        return rows.filter((row) => row.values[id] === filterValue);
      },
      'Cell': ({value, row}) => (
        <Checkbox
          toggle
          checked={value === 'A'}
          className='green'
          onChange={(e, input) => updateStatus(e, input.checked, row.original)}
        />
      ),
    },
    {
      'Header': () => <span className="header-title">ACCIONES</span>,
      'id': 'skills_actions',
      'width': 1,
      'disableFilters': true,
      'Cell': ({row}) => (
        <div className='flex center end'>
          <WtsSkillsModal mode='edit' skillToEdit={row.original} />
        </div>
      ),
    },
  ], [wtsCoursesAreas, skillsData, areaSelected]);

  return (
    <Grid padded>
      <Grid.Row style={{'padding': 0}}>
        <Grid.Column textAlign='left' width={14}>
          <WtsSkillsModal mode='new' />
        </Grid.Column>
        <Grid.Column width={2} textAlign='right'>
          <WtsSkillsTechDetailsModal />
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column width={16}>
          <CommercialTable
            columns={columns}
            data={formattedData}
            defaultColumnFilter={DefaultColumnFilter}
            pagination={true}
            defaultPagination={10}
            initialState={{
              'filters': [
                {
                  'id': 'status',
                  'value': '',
                },
              ],
            }}
          />
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
}

export default WtsSkills;
